import { useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// Custom hook to reset form when the component is mounted
const useResetForm = ({ onMount }) => {
  // Get the search parameters from the URL
  const [searchParam] = useSearchParams();

  // useRef to track if the component is mounted
  const isMounted = useRef(false);

  useEffect(() => {
    // Get the 'new' parameter from the URL
    let isNew = searchParam.get("new");

    // If the component is already mounted and 'new' is true, exit the effect
    if (isMounted?.current && isNew) return;

    // If 'new' is true, set isMounted to true and call the onMount function if it exists
    if (isNew) {
      isMounted.current = true;
      if (onMount) onMount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParam]); // Run the effect when the search parameters change

  return null;
};

export default useResetForm;